export default function advancedToggleRefinement(widgetParams) {
    const {
        container,
        attribute,
        cssClasses: userCssClasses = {},
        templates = {},
        options = [],
    } = widgetParams || {};

    return {
        $$widgetType: "youdji.advancedToggleRefinement",

        init(initOptions) {
            const { instantSearchInstance, helper } = initOptions;

            const _options = options
                .map((option) => {
                    const value = option.value || "";
                    const checked = !option.value ? "checked" : "";

                    return `
                        <li class="${userCssClasses.item}">
                            <label class="${userCssClasses.label}">
                                <input  class="${userCssClasses.radio}" type="radio" name="${attribute}" value="${value}" ${checked} />
                                ${option.label}
                            </label>
                        </li>
                    `;
                })
                .join("");

            container.innerHTML = `
                <div>
                    <ul class="${userCssClasses.list}">
                        ${_options}
                    </ul>
                </div>
            `;

            container.addEventListener("change", (event) => {
                let filters = (helper.state.filters || "")
                    .split(" AND ")
                    .filter((f) => f && !f.includes(`${attribute}:`));

                const value = event.target.value;

                if (value) {
                    filters.push(this.getFilterFromValue(value));
                }

                helper.setQueryParameter("filters", filters.join(" AND ")).search();
            });
        },

        getFilterFromValue(value) {
            if (!value) {
                return "";
            }

            if (value.startsWith("-")) {
                return `NOT ${attribute}:${value.substring(1)}`;
            }

            return `${attribute}:${value}`;
        },
        getValueFromFilter(filter) {
            if (!filter) {
                return "";
            }

            const [attribute, value] = filter.split(":");

            if (filter.startsWith("NOT")) {
                return `-${value}`;
            }

            return value;
        },

        render(renderOptions) {
            const { instantSearchInstance, state } = renderOptions;

            const filters = state.filters || "";

            for (const option of options) {
                const value = option.value || "";
                const element = container.querySelector(`input[value="${value}"]`);

                if (!element) {
                    continue;
                }

                const filter = this.getFilterFromValue(value);

                if (filters) {
                    element.checked = filters.includes(filter);
                } else {
                    element.checked = !filter;
                }
            }
        },

        dispose({ state }) {
            return state.removeDisjunctiveFacet(attribute);
        },
    };
}
